import PropTypes from "prop-types";
import MatchProfilePropType from "./match-profile";
import FilterValuePropType from "./filter-value";

export default PropTypes.shape({
    matchProfile: MatchProfilePropType,
    filters: PropTypes.objectOf(FilterValuePropType).isRequired,
});
